import { GET_DASHBOARD_REPORT, GET_DASHBOARD_CHART_REPORT } from './dashboardTypes'

export default {
  [GET_DASHBOARD_REPORT](state, data) {
    state.dashboardReport = data;
  },
  [GET_DASHBOARD_CHART_REPORT](state , data){
    state.chartReport = data;
  },
}
